/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AvailableUpdatePackageInfo } from './AvailableUpdatePackageInfo';
import {
    instanceOfAvailableUpdatePackageInfo,
    AvailableUpdatePackageInfoFromJSON,
    AvailableUpdatePackageInfoFromJSONTyped,
    AvailableUpdatePackageInfoToJSON,
} from './AvailableUpdatePackageInfo';

/**
 * @type AvailableUpdateUpgradeResponseDtoLatestUpdateInfo
 * 
 * @export
 */
export type AvailableUpdateUpgradeResponseDtoLatestUpdateInfo = AvailableUpdatePackageInfo;


export function AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSON(json: any): AvailableUpdateUpgradeResponseDtoLatestUpdateInfo {
    return AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSONTyped(json, false);
}

export function AvailableUpdateUpgradeResponseDtoLatestUpdateInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableUpdateUpgradeResponseDtoLatestUpdateInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...AvailableUpdatePackageInfoFromJSONTyped(json, true) };
    return  AvailableUpdatePackageInfoFromJSONTyped(json, true);
}

export function AvailableUpdateUpgradeResponseDtoLatestUpdateInfoToJSON(value?: AvailableUpdateUpgradeResponseDtoLatestUpdateInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfAvailableUpdatePackageInfo(value)) {
        return AvailableUpdatePackageInfoToJSON(value as AvailableUpdatePackageInfo);
    }

    return {};
}

/**
 * Check if a given object implements the AvailableUpdateUpgradeResponseDtoLatestUpdateInfo interface.
 */
export function instanceOfAvailableUpdateUpgradeResponseDtoLatestUpdateInfo(value: any): value is AvailableUpdateUpgradeResponseDtoLatestUpdateInfo {
    if (instanceOfAvailableUpdatePackageInfo(value)) return true;
    return false;
}

